import React, { useEffect, useLayoutEffect, useRef } from "react";
import Navigation from "../components/Navigation";
import vidrodzhennyaLogo from "../images/vidrodzhennyaLogo.svg";
import vidrodzennyaBlured from "../images/vidrodzennyaBlured.png";
import Main from "../components/Main";
import History from "../components/History";
import SplitterImage from "../components/SplitImage";
import Flagmans from "../components/Flagmans";
import Products from "../components/Products";
import BuyBlock from "../components/BuyBlock";
import Footer from "../components/Footer";
import { checkAndSetStats } from "../helpers/helpers";
import SEO from "../components/SEO";

function Vidrodzhennya() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#DAD7DD";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("vidrodzhennyaPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-vidrodzhennya">
            <SEO
                title="Колекція Відродження"
                description="Відродження — унікальна православна колекція ювелірних виробів від TSATSKY. Хрестики, іконки та релігійні прикраси ручної роботи."
                url="/vidrodzhennya"
                collection={{ name: "Відродження", description: "Унікальна православна колекція ювелірних виробів" }}
            />
            <Navigation showBack backTo="/" variant="light" />
            <div className="vidrodzhennya_main_wrapper lg:bg-center">
                <Main
                    path="vidrodzhennya"
                    logoImage={vidrodzhennyaLogo}
                    firstTitleLine={"Унікальна православна коллекція від"}
                    textColor="text-black"
                    logoClassNames="my-6"
                    logoAlt="vidrodzhennya Logo"
                    buttonClassNames="vidrodzhennya-button"
                    borderStyles="border-vidrodzhennyaDark"
                    defaultImage={vidrodzennyaBlured}
                />
            </div>

            <div className="bg-vidrodzhennyaDark">
                <History
                    path="vidrodzhennya"
                    containerClassNames="bg-vidrodzhennya text-black"
                    defaultImage={vidrodzennyaBlured}
                />
                <SplitterImage borderStyles="border-vidrodzhennyaDark shadow-bottom" />

                <Flagmans containerClassNames="text-black bg-vidrodzhennya" />
                <Products
                    path="vidrodzhennya"
                    containerClassNames="text-black bg-vidrodzhennya"
                    productTextStyles={`text-black`}
                    productArticleStyles={`text-black`}
                    buttonStyles="bg-vidrodzhennyaDark hover:bg-vidrodzhennyaDarkHover text-white"
                    defaultImage={vidrodzennyaBlured}
                />

                <BuyBlock
                    buttonClassNames={"bg-vidrodzhennyaDark"}
                    buttonTextClassNames={"text-vidrodzhennya"}
                    containerClassNames="text-black bg-vidrodzhennya py-4"
                />
                <Footer
                    containerClassNames={
                        "bg-vidrodzhennyaDark text-vidrodzhennya"
                    }
                    isDark
                />
            </div>
        </div>
    );
}

export default Vidrodzhennya;
